import AboutSection from "./AboutSection";

const AboutPage = ({ title, desc, image, image_type, about_note }) => {
  return (
    <>
      <AboutSection
        title={title}
        desc={desc}
        mediaType={image_type || "image"}
        mediaLink={image}
        points={about_note}
      />
    </>
  );
};

export default AboutPage;
